import React from 'react';
import { motion } from 'framer-motion';
import { ChefHat, Home, Phone, ShoppingCart, Menu, X, Star } from 'lucide-react';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="glass sticky top-0 z-50 border-b border-white/20"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <motion.div
            className="flex items-center space-x-3"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="relative">
              <ChefHat className="w-10 h-10 text-ginger" />
              <motion.div
                className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold gradient-text">Sai Ginger Garlic paste</h1>
              <p className="text-sm text-gray-600 font-medium">🏠 Premium Homemade Paste</p>
            </div>
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {[
              { icon: Home, label: 'Home', href: '#home' },
              { icon: ShoppingCart, label: 'Order', href: '#order' },
              { icon: Phone, label: 'Contact', href: '#contact' },
              { icon: Star, label: 'Reviews', href: '#reviews' },
            ].map((item, index) => (
              <motion.a
                key={item.label}
                href={item.href}
                className="flex items-center space-x-2 text-gray-700 hover:text-ginger transition-colors font-medium"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.3 }}
              >
                <item.icon className="w-4 h-4" />
                <span>{item.label}</span>
              </motion.a>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <motion.button
            className="md:hidden p-2 rounded-lg hover:bg-white/20 transition-colors"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </motion.button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.nav
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden mt-4 pt-4 border-t border-white/20"
          >
            <div className="flex flex-col space-y-4">
              {[
                { icon: Home, label: 'Home', href: '#home' },
                { icon: ShoppingCart, label: 'Order', href: '#order' },
                { icon: Phone, label: 'Contact', href: '#contact' },
                { icon: Star, label: 'Reviews', href: '#reviews' },
              ].map((item) => (
                <motion.a
                  key={item.label}
                  href={item.href}
                  className="flex items-center space-x-3 text-gray-700 hover:text-ginger transition-colors font-medium p-2 rounded-lg hover:bg-white/20"
                  whileHover={{ x: 10 }}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </motion.a>
              ))}
            </div>
          </motion.nav>
        )}
      </div>
    </motion.header>
  );
};
